import type { BaseTableParams } from "@dashboardApi/apis/types";
import type { BaseTableResultItem, TableResult } from "@tanstack/react-table";

import sharedConstants from "@lib/shared_constants.json";

export interface AppsTransformationLogsDatatableParams extends BaseTableParams {
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]>>;
}

export interface AppsTransformationLogsDatatableResultItem extends BaseTableResultItem {
  id: string;
  transformation_name: string;
  transformation_id: string;
  timestamp: string;
  input?: object;
  output?: object;
  response_body?: object;
  result: TransformationExecutionStatus;
  details: string;
  endpoint: TransformationEndpoint;
}

const EXECUTION_STATUSES = sharedConstants.DATA_TRANSFORMATION.EXECUTION_STATUSES;
const ENDPOINTS = sharedConstants.DATA_TRANSFORMATION.ENDPOINTS;

// Type is union of EXECUTION_STATUSES values
export type TransformationExecutionStatus = (typeof EXECUTION_STATUSES)[keyof typeof EXECUTION_STATUSES];
export type TransformationEndpoint = (typeof ENDPOINTS)[keyof typeof ENDPOINTS];

export type AppsTransformationLogsDatatableResult = TableResult<AppsTransformationLogsDatatableResultItem>;
